import api from './index';
//
let exports = {};

exports.saveDeviceMaintPlanForOneServicer = function (data, callback) { // 保存设备保养计划 - 一个服务商一个保养计划
    api.post('/shop/device/maint/plan/save/do/for/oneServicer')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveDeviceMaintPlan = function (data, callback) { // 保存设备保养计划
    api.post('/shop/device/maint/plan/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 更换-计划项的服务商+服务
exports.updateMaintPlanDevice = function (data, callback) { // 批量 - 保存设备保养计划
    api.post('/shop/device/maint/plan/device/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设置设备保养计划截止时间
exports.updateMaintPlanDeviceYqFinishTime = function (data, callback) { // 设置设备保养计划截止时间
    api.post('/shop/device/maint/plan/device/yqFinishTime/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设置设备保养计划要求信息
exports.updateMaintPlanDeviceYqInfo = function (data, callback) { // 设置设备保养计划要求信息
    api.post('/shop/device/maint/plan/device/yqInfo/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDeviceMaintPlanDetailInfo = function (params, callback) { // 获取设备保养计划列表
    api.get('/shop/device/maint/plan/detail/get')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceByNo = function (params, callback) {
    api.get('/shop/device/get/by/no')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devc.js
// module id = 116
// module chunks = 1